import React, { useState/* , useEffect  */} from "react";
import ModificaProdottiNEW from "../modificaProdotti/ModificaProdottiNEW";
import UltimeModificheSchermataPrinc from "./UltimeModificheSchermataPrinc";

function UIultimeModificheOCrea(props) {

    const product = props.product;
    const setProductFunction = props.setProductFunction;
    const utente = props.utente;
    //const tradPermessa = props.tradPermessa;
    const listaNomiProdotto = props.listaNomiProdotto;
    //const charCount = props.charCount;

    //const [prodScelto, setprodScelto] = useState(product);

    function padTo2Digits(num) {
        return num.toString().padStart(2, '0');
      }

    function formatDate(date = new Date()) {
        return [
          date.getFullYear(),
          padTo2Digits(date.getMonth() + 1),
          padTo2Digits(date.getDate()),
        ].join('-');
      }

    const [data1, setData1] = useState(formatDate());
    const [data2, setData2] = useState(formatDate());




    return (
        <div className='center'>
            <div className='cf'>
                {/* <h1>scegli prod o crea nuovo: [input show or create]</h1> */}
                <div className="fl w-100 w-100-ns">
                {product.codiceVS === "NO DATA" && <div className="sfondoBiancoTema">
                        <UltimeModificheSchermataPrinc
                            utente={utente}
                            setProductFunction={setProductFunction}
                            data1={data1}
                            setData1={setData1}
                            data2={data2}
                            setData2={setData2}
                        />                        
                    </div>}
                </div>
                <div className="fl w-100 w-100-ns">
                    <div className="sfondoBiancoTema">
                    
                    {product.codiceVS !== "NO DATA" && <ModificaProdottiNEW
                        prodotto={product}
                        setProductFunction={setProductFunction}
                        utente={utente}
                        listaNomiProdotto={listaNomiProdotto}
                    />}
                    </div>
                </div>
            </div>

        </div>
    )

}

export default UIultimeModificheOCrea;